const moveCursorToEnd = (
    input: HTMLInputElement | HTMLTextAreaElement | HTMLElement,
): void => {
    const element = input;

    if (element.isContentEditable) {
        const range = document.createRange();
        const selection = window.getSelection();

        if (!selection) {
            return;
        }

        if (!element.firstChild) {
            range.selectNodeContents(element);
            range.collapse(false);
            selection.removeAllRanges();
            selection.addRange(range);
            return;
        }

        const textNode: Node = element.firstChild as Node;
        const cursorPosition = element.innerText.length;

        range.setStart(textNode, cursorPosition);
        range.setEnd(textNode, cursorPosition);
        selection.removeAllRanges();
        selection.addRange(range);
        return;
    }

    if (
        input instanceof HTMLInputElement
        || input instanceof HTMLTextAreaElement
    ) {
        const textInput = input;
        textInput.selectionStart = textInput.value.length;
        textInput.selectionEnd = textInput.value.length;
    }
};

export default moveCursorToEnd;
